module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_tractus_calendar-bcbefe3eef9b4251d4beba7679fa7baa.png";